/**
 * Base class for medias extractors : Photo, Background, Sticker
 * Loads files, extract image (HTMLImage) , thumb (base64) and original size and wanted size (ratio)
 */
fx.ns("shared", class MediaExtractor extends fx.EventDispatcher {

    /**
     * parameters :
     * - data : array of object Files
     * - [optional] thumbSize : size of extracted thumb (base64). Default value : 300
     * - [optional] imageMaxSize : max original size for image. Default value : 5000
     * @param {Object} parameters 
     */
    constructor(parameters) {
        super();

        this.data = (parameters && parameters.data) ? parameters.data : null;
        this._thumbSize = (parameters && parameters.thumbSize) ? parameters.thumbSize : 300;
        this._PICTURE_MAX_SIZE = (parameters && parameters.imageMaxSize) ? parameters.imageMaxSize : 5000;

        this._queueFiles = [];
        this._processedFiles = [];

        this._currentFile = {};

        this._imageLoadedHandler = this._onImageLoaded.bind(this);
    }

    get thumbSize() {
        return this._thumbSize;
    }

    set thumbSize(val) {
        this._thumbSize = val;
    }

    get queueFiles() {
        return this._queueFiles;
    }

    get processing() {
        return this._queueFiles.length > 0;
    }

    /*get allFiles()
    {
        return this._queueFiles.concat( this._processedFiles )
    }*/

    get noRevoke() {
        return this._processedFiles.length <= fx.get("settings").noRevokePictures; // don't revoke pictures under 1000
    }

    /**
    * Call this function with array of files to be processed asynchronously
    * @param {Array} files 
    */
    process(files) {
        this._queueFiles = this._queueFiles.concat(files);

        this.processStarting();
        this._processQueue();
    }

    /**
     * Override this function to get each extracted data for each file.
     * Extract data object contains the following properties :
     * - thumb : base64 code corresponding to thumb
     * - width : original image width
     * - height : original image height
     * - orientation : orientation angle
     * - date : date when image was created
     * - file : original File object
     * - image : HTML Image containing image file
     * @param {Object} data 
     */
    onImageExtracted(data) {

    }

    /** To Override in order to do stuff before process starting */
    processStarting() {

    }

    /** To Override in order to do stuff after process finishes */
    processFinished() {
        this._processedFiles = [];
    }

    get total() {
        return this._processedFiles.length + this._queueFiles.length;
    }

    get position() {
        return this._processedFiles.length;
    }

    // ------------------------------ PRIVATE ----------------------- //

    _processQueue() {
        if (this._queueFiles.length == 0) {
            this._currentFile = {};
            this.processFinished();
            return;
        }

        if ((this._currentFile && this._currentFile.processing))
            return;

        this._currentFile.file = this._queueFiles.shift();
        this._processedFiles.push(this._currentFile.file);
        this._currentFile.processing = true;

        if (this._currentFile.file.name.toLowerCase().endsWith(".heic"))
        //if (this._currentFile.isHeic)
        {
            this._manageHeic();
        }
        else {
            this._loadImageFile();
        }
    }

    _loadImageFile() {
        try {
            let loadingImage = loadImage(this._currentFile.file,
                this._imageLoadedHandler,
                {
                    maxWidth: 1000,
                    maxHeight: 1000,
                    downsamplingRatio: 0.7,
                    orientation: true,
                    meta: true,
                    noRevoke: this.noRevoke
                }
            );

            if (!loadingImage)
                this._nextFile();
        }
        catch (e) {
            this._nextFile();
        }
    }

    _manageHeic() {
        try {
            this._heicFileReader = new FileReader();
            this.on("load", this.onHeicReaderLoaded, this._heicFileReader);
            this._heicFileReader.readAsArrayBuffer(this._currentFile.file);

        }
        catch (e) {
            this._nextFile();
        }
    }

    onHeicReaderLoaded() {
        let tags;

        // one reader per file : unbind it, or _binds keeps every file buffer alive
        this.off("load", this.onHeicReaderLoaded, this._heicFileReader);

        // A file named .heic does not always hold a HEIC : a picture exported, converted or simply
        // renamed keeps the extension while the bytes are a jpeg. Read as a HEIC it gives no exif at
        // all, and the photo loses its orientation (the upload server strips the exif and rotates the
        // original with the angle we send, so a 0 leaves it on its side), its date taken and its GPS.
        // When the head says the file is a picture the browser decodes, we rewrite it with its real
        // type and extension - load-image reads the exif of a blob typed image/jpeg only - and hand
        // it to the standard path, which then treats it as the jpeg it is.
        let real = this._realType(this._heicFileReader.result);
        let retyped = real ? this._retypedFile(this._currentFile.file, this._heicFileReader.result, real) : null;

        if (retyped)
        {
            this._currentFile.file = retyped;
            this._loadImageFile();
            return;
        }

        // no retyping possible : the file goes down the HEIC path it has always taken. Handing the
        // original, still typed image/heic, to load-image would lose it altogether on a browser
        // with no HEIC decoder.
        this._currentFile.file.isHeic = true;

        try {
             tags = findEXIFinHEIC(this._heicFileReader.result);
        }
        catch(e)
        {

        }

        let thumbWidth = 150, thumbHeight = 150;

        if (tags && tags.PixelXDimension && tags.PixelYDimension)
        {
            if (tags.PixelYDimension > tags.PixelXDimension) {
                thumbHeight = this.thumbSize;
                thumbWidth = thumbHeight * tags.PixelXDimension / tags.PixelYDimension;
            }
            else {
                thumbWidth = this.thumbSize;
                thumbHeight = thumbWidth * tags.PixelYDimension / tags.PixelXDimension;
            }
        }
        
        let coordinates = this._coordinates(tags);

        // an error here must not stop the queue (it still reaches the error tracking)
        try {
            this.onImageExtracted({
                thumb: fx.assets.imagePlaceHolder.content,
                //width : 1000,
                //height : 1000,
                width : tags ? tags.PixelXDimension : undefined,
                height : tags ? tags.PixelYDimension : undefined,
                orientation: Exif.getOrientationAngle(tags),
                date: (Exif.getDateTaken(tags) || this._currentFile.file.lastModifiedDate),
                file: this._currentFile.file,
                image: null,
                luminance: 0,
                thumbWidth: thumbWidth,
                thumbHeight: thumbHeight,
                latitude: coordinates.latitude,
                longitude: coordinates.longitude
            });
        }
        finally {
            this._nextFile();
        }
    }

    /**
     * Exif.getCoordinates throws on a partial GPS block (GPSLatitudeRef without GPSLatitude nor
     * 0x8825 pointer) : the photo is then kept, without coordinates.
     */
    _coordinates(exif) {
        try {
            return Exif.getCoordinates(exif);
        }
        catch (e) {
            return {};
        }
    }


    /**
     * Reads the head of the buffer : gives the real type of a picture the browser decodes by itself,
     * nothing for a HEIC (its ftyp box) or a format we cannot name.
     */
    _realType(buffer) {
        let head;

        try {
            head = new Uint8Array(buffer, 0, 12);
        }
        catch (e) {
            return null;
        }

        let string = (from, length) => String.fromCharCode.apply(null, head.subarray(from, from + length));

        if (head[0] == 0xFF && head[1] == 0xD8 && head[2] == 0xFF)
            return { type : "image/jpeg", extension : "jpg" };

        if (head[0] == 0x89 && string(1, 3) == "PNG")
            return { type : "image/png", extension : "png" };

        if (string(0, 4) == "RIFF" && string(8, 4) == "WEBP")
            return { type : "image/webp", extension : "webp" };

        if (string(0, 3) == "GIF")
            return { type : "image/gif", extension : "gif" };

        return null;
    }

    /**
     * The same bytes under the same name, with the type and the extension the head gave ; null when
     * the browser has no File constructor, the caller then keeping the HEIC path.
     */
    _retypedFile(file, buffer, real) {
        let retyped;

        try {
            retyped = new File([buffer], file.name.replace(/\.[^.]*$/, "") + "." + real.extension,
                               { type : real.type, lastModified : file.lastModified });
        }
        catch (e) {
            return null;
        }

        retyped.isHeic = false;

        return retyped;
    }


    _onImageLoaded(img, data) {
        /*if (this._temporaryImage)
        {
            img = this._temporaryImage;
            data = {originalWidth : img.width, originalHeight : img.height, date : this._currentFile.file.lastModifiedDate}
            this._temporaryImage = null;
        }*/

        if (!img || img.type === "error") {
            this._nextFile();
            return;
        }

        try {

            let newWidth, newHeight;

            if (img.height > img.width) {
                newHeight = this.thumbSize;
                newWidth = newHeight * img.width / img.height;
            }
            else {
                newWidth = this.thumbSize;
                newHeight = newWidth * img.height / img.width;
            }

            // the file type follows the extension, not the bytes : a .heic decoded here holds a jpeg,
            // and asking the canvas for an image/heic would silently give back a (much heavier) png
            let thumbType = /^image\/(jpeg|png|webp)$/.test(this._currentFile.file.type) ? this._currentFile.file.type : "image/jpeg";

            let dataImg = fx.graphics.imageToDataUri(img, newWidth, newHeight, thumbType);
            let luminance = fx.graphics.getImageLuminance(img, newWidth, newHeight);

            let widthOriginal = Math.min(data.originalWidth, this._PICTURE_MAX_SIZE);
            let heightOriginal = Math.min(data.originalHeight, this._PICTURE_MAX_SIZE);
            let coordinates = this._coordinates(data.exif);


            if (data.originalWidth > data.originalHeight)
                heightOriginal = widthOriginal * img.height / img.width;
            else
                widthOriginal = heightOriginal * img.width / img.height;

            this.onImageExtracted({
                thumb: dataImg,
                width: widthOriginal,
                height: heightOriginal,
                orientation: (img.errorRotate ? 0 : Exif.getOrientationAngle(data.exif)),
                date: (data.date || Exif.getDateTaken(data.exif) || ""),
                file: this._currentFile.file,
                image: img,
                blob: this.noRevoke ? img.src : "",
                luminance: luminance,
                thumbWidth: newWidth,
                thumbHeight: newHeight,
                latitude: coordinates.latitude,
                longitude: coordinates.longitude
            });


            this._nextFile();

        }
        catch (e) {
            this._nextFile();
        }
    }

    _nextFile() {
        if (this._currentFile)
            this._currentFile.processing = false;

        this.delay(this._processQueue);
    }


});